import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

/* eslint-disable prettier/prettier */
import cx from 'classnames';
import React from 'react';
export var NavItem = function NavItem(_ref) {
  var _ref2;

  var animated = _ref.animated,
      children = _ref.children,
      className = _ref.className,
      endIcon = _ref.endIcon,
      _ref$hideOn = _ref.hideOn,
      hideOn = _ref$hideOn === void 0 ? [] : _ref$hideOn,
      highlighted = _ref.highlighted,
      readOnly = _ref.readOnly,
      selected = _ref.selected,
      startIcon = _ref.startIcon,
      weight = _ref.weight,
      leading = _ref.leading,
      leadingText = _ref.leadingText,
      trailing = _ref.trailing,
      trailingText = _ref.trailingText,
      icon = _ref.icon,
      caption = _ref.caption,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["animated", "children", "className", "endIcon", "hideOn", "highlighted", "readOnly", "selected", "startIcon", "weight", "leading", "leadingText", "trailing", "trailingText", "icon", "caption", "variant"]);

  /**
   * Handle dynamically wrapping leading/trailing content in spans when needed to preserve flex layout
   * - If multiple elements are to be aligned leading/trailing in vertical layouts, wrap them
   * - If raw text would be placed next to element(s), wrap it
   */
  // If there are multiple elements to place in a leading slot together
  var leadingHasMultiple = (leading === null || leading === void 0 ? void 0 : leading.type) === React.Fragment;
  var wrapLeading = Boolean(leading && leadingText) || leadingHasMultiple; // If there are multiple elements to place in a leading slot together

  var trailingHasMultiple = (trailing === null || trailing === void 0 ? void 0 : trailing.type) === React.Fragment;
  var wrapTrailing = Boolean(trailing && trailingText) || trailingHasMultiple; // If the leadingText should be wrapped in a span

  var wrapLeadingText = leadingText && (wrapLeading || caption || leadingText && (trailing || trailingText)); // If the leadingText should be wrapped in a span

  var wrapTrailingText = trailingText && (wrapTrailing || trailingText && (leading || leadingText));
  /**
   * Parse & wrap content slots to preserve flex layout without rendering empty/redundant spans
   */
  // Wrap the text in a span if it would be placed right against another element to preserve flex-gap

  var leadingTextSlot = wrapLeadingText ? React.createElement("span", null, leadingText, caption && React.createElement("span", {
    className: "tds-site-nav-item-caption"
  }, caption)) : leadingText; // Wrap the leading stuff in a span to align everything within to the start

  var leadingSlot = wrapLeading ? React.createElement("span", {
    className: "tds-site-nav-item-leading"
  }, leading, leadingTextSlot) : leading || leadingTextSlot; // Wrap the text in a span if it would be placed right against another element to preserve flex-gap

  var trailingTextSlot = wrapTrailingText ? React.createElement("span", null, trailingText) : trailingText; // Wrap the leading stuff in a span to align everything within to the end

  var trailingSlot = wrapTrailing ? React.createElement("span", {
    className: "tds-site-nav-item-trailing"
  }, trailingTextSlot, trailing) : trailing || trailingTextSlot;
  var content = React.createElement(React.Fragment, null, leadingSlot, icon, !icon && startIcon, children && React.createElement("span", {
    className: "tds-site-nav-item-text"
  }, children), !icon && endIcon, trailingSlot);
  /**
   * Define props common to all types of wrapper elements
   */

  var explicitProps = {
    'aria-expanded': selected,
    className: cx.apply(void 0, ['tds-site-nav-item'].concat(_toConsumableArray(hideOn.map(function (value) {
      return "tds--hideon-".concat(value);
    })), [(_ref2 = {}, _defineProperty(_ref2, "tds-text--".concat(weight), weight), _defineProperty(_ref2, 'tds--highlighted', highlighted), _defineProperty(_ref2, 'tds-animate--backdrop', animated && !readOnly), _defineProperty(_ref2, 'tds-site-nav-item--read-only', readOnly), _defineProperty(_ref2, 'tds-site-nav-item--with-caption', caption), _defineProperty(_ref2, 'tds-site-nav-item--icon-only', icon), _defineProperty(_ref2, "tds-site-nav-item--".concat(variant), variant), _ref2), className]))
  };
  /**
   * Decide what kind of wrapper to put the contents into
   */

  if (readOnly) {
    return React.createElement("span", _objectSpread(_objectSpread({}, rest), explicitProps), content);
  }

  if ('href' in rest && rest.href) {
    return React.createElement("a", _objectSpread(_objectSpread({}, rest), explicitProps), content);
  }

  return (// @ts-expect-error - improper TypeScript error
    // (JSX attribute) React.ButtonHTMLAttributes<HTMLButtonElement>.type?: "button" | "submit" | "reset" | undefined
    // Type 'string' is not assignable to type '"button" | "submit" | "reset" | undefined'.ts(2322)
    React.createElement("button", _objectSpread(_objectSpread({
      type: "button"
    }, rest), explicitProps), content)
  );
};